import React, { useState, useEffect } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import axiosClient from "../../../utils/axiosClient";
import { urlListarCalendario } from "../../../utils/constants";
import { IonButton, IonItem, IonList, IonLabel } from "@ionic/react";

import StatusAgendamento from "../../../components/global/StatusAgendamento";
import moment from "moment";
import "moment/locale/pt-br";

moment().locale("pt-br");

export default function CalendarioSemanaEmpresas({ retornaData }) {
  const navigate = useNavigate();

  const [itens, setItens] = useState([]);
  const [diaBuscado, setDiaBuscado] = useState(moment().format("YYYY-MM-DD"));
  const [diaF, setDiaF] = useState(moment().format("YYYY-MM-DD"));

  const [datasBusca, setDatasBusca] = useState(getWeekDates(diaBuscado));
  const [agendamentos, setAgendamentos] = useState([]);

  function getWeekDates(date) {
    const inputDate = moment(date);
    const startOfWeek = inputDate.clone().startOf("week");
    const weekDates = [];

    for (let i = 0; i < 7; i++) {
      weekDates.push(startOfWeek.clone().add(i, "days").format("YYYY-MM-DD"));
    }

    return {
      weekDates,
    };
  }

  const proximaSemana = () => {
    let dia = moment(diaF).add(7, "days").format("YYYY-MM-DD");
    setDiaF(dia);
  };

  const semanaAnterior = () => {
    let dia = moment(diaF).subtract(7, "days").format("YYYY-MM-DD");
    setDiaF(dia);
  };

  function filterByDate(date, array) {
    if(Array.isArray(array)){
      const formattedDate = moment(date).format("YYYY-MM-DD");
      return array.filter(
        (item) => moment(item.dia).format("YYYY-MM-DD") === formattedDate
      );
    } else {
      return;
    }
  }

  const consultaLista = async (datas) => {
    try {
      const response = await axiosClient.post(urlListarCalendario, {
        datas: datas,
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const consultarItens = async (datas) => {
    const lista = await consultaLista(datas);
    setItens(lista);
  };

  useEffect(() => {
    let datasB = getWeekDates(diaF);
    if (datasB.weekDates) {
      consultarItens(datasB.weekDates);
      setDatasBusca(datasB);
    }
  }, [diaF]);

  useEffect(() => {
    const agendamentosData = filterByDate(diaBuscado, itens);
    if(Array.isArray(agendamentosData)){
      if (agendamentosData.length > 0 && agendamentosData[0].agendamentos) {
        const originalData = agendamentosData[0].agendamentos;
        const orderedData = {};
        let newIndex = 0;
  
        for (const key in originalData) {
          orderedData[newIndex] = originalData[key];
          newIndex++;
        }
  
        const orderedArray = Object.values(orderedData);
  
        setAgendamentos(orderedArray);
      }
    }
   
  }, [itens, diaBuscado]);

  return (
    <div>
      <br />
      <div className="row">
        <div className="col-5">
          <div className="ion-margin-horizontal ion-text-start">
            <h6
              className="tituloPagina"
              style={{ textTransform: "capitalize", fontSize: "16px" }}
            >
              Agendamentos
            </h6>
          </div>
        </div>
        <div className="col-7">
          <div
            className="ion-margin-horizontal ion-text-end"
            style={{
              backgroundColor: "#f4f5f8",
              borderRadius: "11px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <IonButton
              color="secondary-light"
              style={{ width: "30px", height: "30px" }}
              onClick={semanaAnterior}
            >
              <i className="ri-arrow-left-s-line"></i>
            </IonButton>
            <h6
              className="tituloPagina"
              style={{ textTransform: "capitalize", fontSize: "14px" }}
            >
              {moment(diaF).format("MMMM")} {moment(diaF).format("YYYY")}
            </h6>
            <IonButton
              color="secondary-light"
              style={{ width: "30px", height: "30px" }}
              onClick={proximaSemana}
            >
              <i className="ri-arrow-right-s-line"></i>
            </IonButton>
          </div>
        </div>
      </div>
      <div
        className="rowSemana"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 0",
        }}
      >
        {datasBusca.weekDates.map((dia, index) => {
          const isSelected =
            moment(dia).format("YYYY-MM-DD") ===
            moment(diaBuscado).format("YYYY-MM-DD");

          return (
            <div
              key={index}
              style={{
                width: "14%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {/* Cápsula oval que envolve tudo */}
              <div
                onClick={() => {
                  setDiaBuscado(dia);
                  retornaData(dia);
                }}
                style={{
                  width: "45px",
                  height: "70px",
                  borderRadius: "30px",
                  backgroundColor: isSelected ? "#141458" : "#ffffff",
                  color: isSelected ? "#ffffff" : "#141458",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "0.3s",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: isSelected ? "#ffffff" : "#F6F6F7",
                    color: "#141458",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {moment(dia).format("D")}
                </div>

                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: "500",
                    marginTop: "5px",
                    textTransform: "uppercase",
                  }}
                >
                  {moment(dia).format("ddd")}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <IonList>
        {Array.isArray(agendamentos) && (
          <>
            {agendamentos.map((row, index) => (
              <IonItem
                key={index}
                onClick={() => {
                  navigate({
                    pathname: "/empresas/agendamento",
                    search: createSearchParams({
                      id: row.id,
                    }).toString(),
                  });
                }}
              >
                <IonLabel>
                  <h5
                    style={{
                      textTransform: "capitalize",
                      fontWeight: 700,
                    }}
                  >
                    {moment(row.data_agendamento).format("D")} de{" "}
                    {moment(row.data_agendamento).format("MMMM")} de{" "}
                    {moment(row.data_agendamento).format("YYYY")} :{" "}
                    {moment("2023-01-01 " + row.horario_inicial).format(
                      "HH:mm"
                    )}{" "}
                    -{" "}
                    {moment("2023-01-01 " + row.horario_final).format("HH:mm")}
                  </h5>
                  <h5>Serviço: {row.servico}</h5>
                  <h5>Cliente: {row.cliente_nome}</h5>
                  <StatusAgendamento
                    status={row.status}
                    data={row.data_agendamento}
                  />
                  <p
                    style={{
                      marginTop: "7px",
                      marginBottom: "5px",
                    }}
                  >
                    <i className="ri-information-line"></i> &nbsp; {row.obs}
                  </p>
                </IonLabel>
              </IonItem>
            ))}
          </>
        )}
      </IonList>
    </div>
  );
}
